var lx = lx || {};
lx.calendar = lx.calendar || {};

lx.calendar.get = function (pId, pEntity, pThis) {
    $(".calendar_dialog").remove();
    lx.load.add();
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getCalendarDetails",
            x01: pEntity,
            x02: pId
        },
        success: function (d) {
            var dialogHtml = '<div class="calendar_dialog">' + d + '</div>';
            $("body").append(dialogHtml);
            $('html, body').animate({ scrollTop: $(".cal_notify-hrd").offset().top }, 500);
            lx.comment.initAll();
			$('#ShowInCalBtn').hide();
            lx.load.remove();
        }
    });
};


// TODO cleanup after we ditch the old app
var getCalendarInfo = lx.calendar.get;